import React from "react";
import {logout, parseURL, isValidLogoutURL} from "account-portal-library/lib/helperFunctions";
import AppVars from '../AppVars';
import Logger from '../Logger.js';
import Loader from './Loader';

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            logoutUriMissing: false,
            logoutRedirectUri: null,
            defaultUrl: appVars.getDefaultHomePage(),
            style: "TO"
        }
    }

    async componentDidMount() {
        try {
            sessionStorage.removeItem("AP_SSID")
            sessionStorage.removeItem("AP_authId")
            logger.log("test", "calling the logout function to remove lingering cookies")
            const logoutResponse = await logout(appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
            logger.log("test", logoutResponse);
            const logoutRedirectUri = this.parseLogoutRedirectUri(window.location.search)
            logger.log("test", logoutRedirectUri)
            if (!logoutRedirectUri) {
                logger.log('test', 'post_logout_redirect_uri is not present in the url params')
                this.setState({
                    logoutUriMissing: true,
                    logoutRedirectUri: logoutRedirectUri
                })
            } else {
            if (this.isUnsafeRedirectUri(logoutRedirectUri)) {
                this.setState({
                    logoutUriMissing: true,
                    logoutRedirectUri: null
                });
                window.location.replace(this.state.defaultUrl);
                return;
            }
            this.setState({ logoutRedirectUri: logoutRedirectUri });
        }

        // Determine if its LD or DG
        const hash = window.location.hash

        if (hash.includes("dg") || hash.includes("DG")){
            this.setState({style: "DG"})
        }
            
        } catch (error) {
            logger.log("test", "Error during logout:", error);
            this.setState({
                logoutUriMissing: true,
                logoutRedirectUri: null
            });
            
        }
        
    }

    parseLogoutRedirectUri = (url) => {
        let logoutRedirectUri = ""
        if (Object.keys(parseURL(url)).includes('post_logout_redirect_uri')) {
            logger.log('test', 'post_logout_uri encoded: ' + parseURL(url)['post_logout_redirect_uri'])
            logoutRedirectUri = decodeURIComponent(parseURL(url)['post_logout_redirect_uri'])
        }
        return logoutRedirectUri
    }

    // New method to check for unsafe URLs
    isUnsafeRedirectUri = (uri) => {
        // Regex to detect any potential XSS or JavaScript injection
        const unsafePattern = /^(javascript:|data:text\/html|eval\(|onerror=|onload=|vbscript:|data:image\/svg\+xml|about:|window\.|document\.)/i;
        
        return unsafePattern.test(uri);
    }

    render() {
        if (this.state.logoutRedirectUri === null) {
            return (<Loader/>)
        }
        else if (this.state.logoutUriMissing) {
            window.location.replace(this.state.defaultUrl);
            return ""
        }

        else if (this.state.logoutRedirectUri) {
            logger.log('test', 'post_logout_redirect_uri query param present with value ' + this.state.logoutRedirectUri);
            if (isValidLogoutURL("T", this.state.logoutRedirectUri)){
                window.location.replace(this.state.logoutRedirectUri);
                return ""
            }else{
                window.location.replace(this.state.defaultUrl);
                return ""
            }

        }

        else {
            // Wait for component did mount to populat the state values
            return (
                <Loader />
            )
        }
    }
}

export default Logout;
